module.exports = __webpack_public_path__ + "media/images/favicon-9f57fd1f7b05f41c6798f5a0254ae28d.png";